import React from "react";
import "./style.css";

export default function SubExpired() {
  return <div>index</div>;
}
